let ga4SessionActive = false

export function isGa4Ready(): boolean {
  return ga4SessionActive && typeof window !== 'undefined' && !!window.gtag
}

export function initGa4Session(userId: string | number): void {
  if (typeof window === 'undefined' || !window.gtag || userId == null || userId === '') return
  const uid = String(userId)
  const env = (import.meta.env.VITE_APP_COUNTRY as string) || 'US'
  window.gtag('set', {
    user_id: uid,
    user_properties: {
      settlement_user_id: uid,
      settlement_environment: env,
    },
  })
  ga4SessionActive = true
  trackAction('login', 'session')
}

export function endGa4Session(): void {
  if (!isGa4Ready()) return
  trackAction('logout', 'session')
  window.gtag('set', {
    user_id: null,
    user_properties: { settlement_user_id: null, settlement_environment: null },
  })
  ga4SessionActive = false
}

export function trackPageView(path: string): void {
  if (!isGa4Ready()) return
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  })
}

type ActionType = 'search' | 'upload' | 'download' | 'export' | 'approve' | 'reject' | 'login' | 'logout'

export function trackAction(action: ActionType, target: string): void {
  if (!isGa4Ready()) return
  window.gtag('event', action, {
    action_target: target,
    page_name: window.location.pathname.replace(/^\//, '') || 'home',
  })
}
